import styled from '@emotion/styled';
import { StyledProps } from './NavLink.types';
import { css } from '@styled-system/css';
import { variant } from 'styled-system';
import { Variant } from '../Nav.types';

export const agentHas = (keyword: string) => navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;

export const isFirefox = agentHas('Firefox') || agentHas('FxiOS') || agentHas('Focus');

const websiteActiveLink = css({
  borderWidth: '1px',
  fontWeight: 'bold',
  color: 'var(--color-lime)',
});

const whiteActiveLink = css({
  borderWidth: '1px',
  fontWeight: 'bold',
  color: 'var(--color-indigo)',
});

const lightActiveLink = css({
  borderWidth: '1px',
  fontWeight: 'bold',
  color: 'var(--color-indigo)',
});

const darkActiveLink = css({
  borderWidth: '1px',
  fontWeight: 'bold',
  color: 'var(--color-lime)',
});

const activeLinkMap = new Map<Variant, string>([
  ['website', websiteActiveLink],
  ['white', whiteActiveLink],
  ['light', lightActiveLink],
  ['dark', darkActiveLink],
]);

export default styled.li<StyledProps, any>`
  ${css({
    textDecoration: 'none',
    fontSize: '14px',
    fontFamily: 'secondary',
  })}

  & > * > svg:first-child {
    margin-right: 6px;
  }

  & > * > svg:last-child {
    margin-left: 6px;
  }

  ${isFirefox &&
  `
    & > * span {
    height: 24px;
    line-height: 27px;
  }
    `}

  & > * {
    ${css({
      cursor: 'pointer',
      borderRadius: 1,
      px: 3,
      py: 2,
      color: 'inherit',
      textDecoration: 'none',
      background: 'transparent',
      border: 'none',
      alignItems: 'center',
      display: 'flex',
    })}

    ${variant({
      prop: 'variant',
      variants: {
        website: {
          color: 'var(--color-extra-white)',
          '&:hover': {
            bg: 'var(--color-indigo-t5)',
          },
          '&:active': {
            ...websiteActiveLink,
          },
        },
        white: {
          color: 'var(--color-indigo-t11)',
          '&:hover': {
            bg: 'var(--color-vibrant-blue-t2)',
          },
          '&:active': {
            ...whiteActiveLink,
          },
        },

        light: {
          color: 'var(--color-indigo-t11)',
          '&:hover': {
            bg: 'var(--color-vibrant-blue-t2)',
          },
          '&:active': {
            ...lightActiveLink,
          },
        },
        dark: {
          color: 'var(--color-extra-white)',
          '&:hover': {
            bg: 'var(--color-vibrant-blue-t8)',
          },
          '&:active': {
            ...darkActiveLink,
          },
        },
      },
    })}
    ${(p) =>
      variant({
        prop: 'status',
        variants: {
          active: activeLinkMap.get(p.variant),
        },
      })}
  }
`;
